export default "__VITE_ASSET__BUecJlxC__"